import Flickity from './Flickity';

const sliderConfig = {
  prevNextButtons: false,
  adaptiveHeight: false,
  draggable: false,
};

export default class HomeEvents {
  constructor(element) {
    this.element = element;

    // Exit if we don't have more than one slide.
    if (!this.shouldBuildSlider) return;

    // Build Slider
    this.buildSlider();
  }

  buildSlider() {
    this.slider = new Flickity(this.sliderElement, sliderConfig);
  }

  get shouldBuildSlider() {
    return this.slides.length > 1;
  }

  get sliderElement() {
    return this.element.querySelector('.view-content');
  }

  get slides() {
    return this.sliderElement.childNodes;
  }
}
